import P2Regular from 'components/typography/P2Regular';
import { UserRow } from 'components/tables/data/user/types';

/**
 * Column for the role name.
 */
export default function RoleNameColumn({ data: { role } }: { data: UserRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {role.roleName}
    </P2Regular>
  );
}
